export const PRIMARY_FILTERS = [
    {
        value: "Date Range",
        key: "orderDate",
        storeCode : "orderDate",
    },
    {
        value: "Dispatch Location",
        key: "site_code",
        code: "site_name",
        entity: "supplymint.tenant_mapped_sites",
        storeCode: "dispatchLocationCode",
        other_data: {
            dispatch_enable: [1]
        }
    },
    {
        value: "Customer",
        code: "customer_name",
        key: "customer_code",
        entity: "somain",
        storeCode: "customerCode"
    },
    {
        value: "Delivery Location",
        code: "code",
        key: "name",
        entity: "adm_sites",
        storeCode: "deliveryLocationCode",
        other_data: {
            is_secondary_site: [1]
        }
    },
    {
        value: "Division",
        code: "hl1_name",
        key: "hl1_code",
        entity: "item",
        storeCode: "hl1code"
    },
    {
        value: "Section",
        code: "hl2_name",
        key: "hl2_code",
        entity: "item",
        storeCode: "hl2code"
    },
    {
        value: "Department",
        code: "hl3_name",
        key: "hl3_code",
        entity: "item",
        storeCode: "hl3code"
    },
];

export const PRIMARY_FILTERS_ADAM_SOSN = [
    {
        value: "Item Name",
        code: "itemname",
        key: "itemname",
        entity: "product_catalogue_vw",
        storeCode: "itemname"
    },
    {
        value: "Category",
        code: "cname",
        key: "cname",
        entity: "sm_category_description_master",
        storeCode: "category",
        other_data: {
            cat_desc_udf: ["CAT1"]
        }
    }
];

export const PRIMARY_FILTERS_CUSTOMER = [
    {
        value: "Date Range",
        key: "orderDate",
        storeCode : "orderDate",
    },
    {
        value: "Dispatch Location",
        key: "site_code",
        code: "site_name",
        entity: "supplymint.tenant_mapped_sites",
        storeCode: "dispatchLocationCode",
        other_data: {
            dispatch_enable: [1]
        }
    },
    {
        value: "Delivery Location",
        code: "code",
        key: "name",
        entity: "adm_sites",
        storeCode: "deliveryLocationCode",
        other_data: {
            is_secondary_site: [1]
        }
    },
    {
        value: "Division",
        code: "hl1_name",
        key: "hl1_code",
        entity: "item",
        storeCode: "hl1code"
    },
    {
        value: "Section",
        code: "hl2_name",
        key: "hl2_code",
        entity: "item",
        storeCode: "hl2code"
    },
    {
        value: "Department",
        code: "hl3_name",
        key: "hl3_code",
        entity: "item",
        storeCode: "hl3code"
    },
];

export const REPORT_FILTER = [
    {
        value: "name1",
        key: "name1",
        code: "name1",
        entity: "site",
        storeCode : "name1",
    },
    {
        value: "displayname",
        key: "displayname",
        code: "displayname",
        entity: "site",
        storeCode : "displayname",
    },
]

// debounce function 
export function debounce(func, delay) {
    let timeoutId;

    return function (...args) {
        const context = this;

        clearTimeout(timeoutId);

        timeoutId = setTimeout(() => {
            func.apply(context, args);
        }, delay);
    };
}

export const MAIN_FILTERS = [
    {
        value: "Brand",
        key: "brand",
        entity: "product_catalogue_vw",
        storeCode : "Brand",
    },
    {
        value: "Department",
        key: "department",
        entity: "product_catalogue_vw",
        storeCode : "Department",
    },
    {
        value: "Design No",
        key: "design_group_no",
        entity: "product_catalogue_vw",
        storeCode : "Design No",
    },
    {
        value: "Colour",
        key: "color",
        entity: "product_catalogue_vw",
        storeCode : "Colour",
    }
];

export const CUSTOMER_FILTERS = [
    {
        value: "Customer Name",
        key: "customer_name",
        entity: "somain",
        storeCode : "Customer Name",
    },
    {
        value: "Customer Code",
        key: "customer_code",
        entity: "somain",
        storeCode : "Customer Code",
    },
];